import React, { useMemo } from 'react';
import { IconContext } from 'react-icons';
import { MdCheckCircle, MdInfo, MdReport, MdWarning } from 'react-icons/md';
import styled from 'styled-components';

import { theme } from '../../theme';
import { AlertTypeEnum, IAlert } from './alert.types';

const AlertContainer = styled.div<{ type: AlertTypeEnum }>`
	${(props) => theme.getAlertStyles(props.type)} border-radius: 4px;
	padding: 12px 18px;
	display: inline-grid;
	grid-template-columns: auto auto;
	column-gap: 10px;
`;

export const Alert = ({ children, type }: IAlert) => {
	const AlertIcon = useMemo(
		() => ({
			[AlertTypeEnum.TIP]: <MdCheckCircle className="icon" />,
			[AlertTypeEnum.NOTE]: <MdInfo className="icon" />,
			[AlertTypeEnum.WARNING]: <MdWarning className="icon" />,
			[AlertTypeEnum.DANGER]: <MdReport className="icon" />,
		}),
		[]
	);
	return (
		<AlertContainer type={type}>
			<IconContext.Provider value={{ color: theme.colors.alert.icon[type], size: '20px' }}>
				{AlertIcon[type]}
			</IconContext.Provider>
			{children}
		</AlertContainer>
	);
};
